module.exports = __webpack_public_path__ + "img/video.0f08313d.svg";